/**
 * AdminPage Component
 * Stacks Auto-Provisioning and Email Credentials workflows
 */

import React from "react";

import { AutoProvisioning } from "@perfectserve/auto-provisioning";
import { EmailCredentials } from "@perfectserve/email-credentials";

import "./AdminPage.css";

export const AdminPage = () => {
  return (
    <div className="admin-page">
      <div className="admin-page__container">
        <section className="admin-page__section">
          <AutoProvisioning />
        </section>

        <section className="admin-page__section">
          <EmailCredentials />
        </section>
      </div>
    </div>
  );
};

export default AdminPage;
